export const LOCAL_STORAGE_KEY = 'hs-rich-text';